import IServerOperation from './interface/IServerOperation'

/**
 * 缓冲查询
 */
export default class Buffer extends IServerOperation {
    params = { REQUEST: 'BufferAnalysis' }

    constructor(serviceUrl, proxyUrl) {
        super(serviceUrl, proxyUrl)

        this.operation = 'buffer'
        this._bufferType = 1
        this._bufferAccuracy = 32
    }

    /**
     * @override
     * @param  {...any} rest
     */
    async _process(fc, distacne, { wpsType = false } = {}) {
        return super._process(fc, distacne).then(result => {
            // SAS类型操作
            if (this._type === 'SAS') {
                if (wpsType) {
                    return result.map(f => {
                        if (f.geometry.type === 'Polygon') {
                            if (f.geometry.coordinates.length == 2) {
                                f.geometry.coordinates = [
                                    f.geometry.coordinates[0]
                                ]
                            }
                            return f
                        }
                    })
                }
                // 保存原图形
                result.push(...fc)
                return result
            }
            // WPS操作类型
            else {
                if (wpsType) {
                    return result
                }
                // 保存原图形
                result.features.push(...fc)
                return result
            }
        })
    }

    absBuildExecute(fc, distacne) {
        if (this._type === 'SAS') {
            return {
                BufferAnalysis: {
                    service: 'OverlapService',
                    version: '1.0.0',
                    layerJson: {
                        type: 'FeatureCollection',
                        features: fc.map(f => {
                            delete f.properties
                            return f
                        })
                    },
                    bufferRadius: this._meter2Degree(distacne),
                    bufferStyle: 'round',
                    bufferType: 'outside',
                    isSynchronization: 'true',
                    outPutFormat: 'geojson'
                }
            }
        } else {
            return [
                IServerOperation.GeoJson2GML(fc),
                this._meter2Degree(distacne),
                this._bufferType,
                this._bufferAccuracy
            ]
        }
    }

    _meter2Degree(distacne) {
        return 0.000008983152841195214 * distacne
    }
}
